import React from 'react';
import { Col } from "reactstrap";
import _ from 'lodash'

export default function Checkbox({
    index,
    onClick,
    onChange,
    className,
    ativo,
    obrigatorio,
    bloqueado,
    valor
}) {


    const handleChange = ({target: { checked }}) => {
        if (onChange) onChange(checked)
    }

    const handleClick = () => onClick(index)

    return (
        <Col xs={12} md={6} lg={4} className={`checkbox-col ${className || ""}`}>
            <label className="control control-checkbox">
                <label
                    className={ativo ? "" : "label-disabled"}
                    onClick={!obrigatorio ? handleClick : () => null}>
                    {_.get(valor, 'label') ? valor.label : valor}
                </label>
                <span>
                    <input
                        type="checkbox"
                        onChange={handleChange}
                        checked={ativo}
                        disabled={bloqueado ? bloqueado : obrigatorio} />
                    <div className="control_indicator" onClick={handleClick}></div>
                </span>
                <div className="clearboth"></div>
            </label>
        </Col>
    )
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/Checkbox.js